/* eslint-disable */
import React, { useState } from "react";
import Header from "./components/Header";
import Page from "./components/Page";
import Mapa from "./components/Mapa";
import ManchesterData from "./assests/data/manchester.json";
import Card from "./components/Card";

const App = () => {
  const [isHotspot, setisHotspot] = useState(null);
  const [isMapView, setisMapView] = useState(false);
  const Cards = ManchesterData.map((o) => {
    return <Card key={o.number} hotspot={o} setisHotspot={setisHotspot} />;
  });

  return (
    <>
      <Page navbar={<Header />}>
        <div className="home-container-rod-floating">
          <div
            onClick={() => setisMapView((prev) => !prev)}
            className={
              isMapView
                ? "home-container-rod-floating-map media-icon"
                : "home-container-rod-floating-map-close"
            }
          >
            Map
          </div>
          <div
            onClick={() => setisMapView((prev) => !prev)}
            className={
              isMapView
                ? "home-container-rod-floating-list-close"
                : "home-container-rod-floating-list media-icon"
            }
          >
            Hotspots
          </div>
        </div>
        <div
          className={
            !isMapView
              ? "home-container-rod-floating-hotspot-close"
              : "home-container-rod-floating-hotspot"
          }
        >
          {isMapView && (
            <div className="home-container-rod-floating-hotspot-holder">
              {Cards}
            </div>
          )}
        </div>

        <div className="home-container-rod">
          <div className="home-container-rod-left">
            <div className="home-container-rod-left-cards-container">
              {Cards}
            </div>
          </div>
          <div className="home-container-rod-right">
            <Mapa
              data={ManchesterData}
              isHotspot={isHotspot}
              setisHotspot={setisHotspot}
            />
          </div>
        </div>
      </Page>
    </>
  );
};

export default App;
